var exports = {
  "rY": "PlutoniumContent.module__giftModeContainer___QnFxMF",
  "rs": "PlutoniumContent.module__mainContainer___QnFxMF",
  "wx": "PlutoniumContent.module__header___QnFxMF",
  "DD": "PlutoniumContent.module__title___QnFxMF",
  "h_": "PlutoniumContent.module__description___QnFxMF",
  "xd": "PlutoniumContent.module__subscriptionSection___QnFxMF",
  "fv": "PlutoniumContent.module__disclaimerContainer___QnFxMF",
  "F4": "PlutoniumContent.module__perksSection___QnFxMF",
  "pD": "PlutoniumContent.module__comparisonTableContainer___QnFxMF",
  "MT": "PlutoniumContent.module__redeemSection___QnFxMF",
  "$r": "PlutoniumContent.module__redeemDescription___QnFxMF",
};

module.exports = exports;
